<template>
  <div class="messages-subscriptions ">
    <div class="a-container-form ">
      <div class="a-label a-label--w-280">{{$t('form.messages.settings.receive-all-messages')}}:</div>
      <dropdown-new class="select-w-480" :disabled="isSeparated" v-model="settings.all" @change="saveSettings">
        <option value="None" :label="'form.messages.settings.nowhere'"></option>
        <option value="Email" :label="'form.messages.settings.email'"></option>
        <option value="Inner" :label="'form.messages.settings.internal-messaging'"></option>
        <option value="EmailInner" :label="'form.messages.settings.email-and-internal-messaging'"></option>
      </dropdown-new>
    </div>
    <div class="a-container-form ">
      <div class="a-checkbox">
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="isSeparated" @change="saveSettings">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text">
             {{$t('form.messages.settings.configure-different-message-types')}}:
          </span>
        </label>
      </div>
    </div>
    <div class="messages-subscriptions__content-left-indent">
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.messages.settings.news')}}</div>
        <dropdown-new class="select-w-480" :disabled="!isSeparated" v-model="settings.news" @change="saveSettings">
          <option value="None" :label="'form.messages.settings.nowhere'"></option>
          <option value="Email" :label="'form.messages.settings.email'"></option>
          <option value="Inner" :label="'form.messages.settings.internal-messaging'"></option>
          <option value="EmailInner" :label="'form.messages.settings.email-and-internal-messaging'"></option>
        </dropdown-new>
      </div>
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.messages.settings.tender-in-category')}}</div>
        <dropdown-new class="select-w-480" :disabled="!isSeparated" v-model="settings.category" @change="saveSettings">
          <option value="None" :label="'form.messages.settings.nowhere'"></option>
          <option value="Email" :label="'form.messages.settings.email'"></option>
          <option value="Inner" :label="'form.messages.settings.internal-messaging'"></option>
          <option value="EmailInner" :label="'form.messages.settings.email-and-internal-messaging'"></option>
        </dropdown-new>
      </div>
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.messages.settings.2-days-left-before-deadline-of-sending-request')}}</div>
        <dropdown-new class="select-w-480" :disabled="!isSeparated" v-model="settings.remind" @change="saveSettings">
          <option value="None" :label="'form.messages.settings.nowhere'"></option>
          <option value="Email" :label="'form.messages.settings.email'"></option>
          <option value="Inner" :label="'form.messages.settings.internal-messaging'"></option>
          <option value="EmailInner" :label="'form.messages.settings.email-and-internal-messaging'"></option>
        </dropdown-new>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: () => ({
      isSeparated: false,
      settings: {
        all: 'None',
        news: 'None',
        category: 'None',
        remind: 'None'
      }
    }),

    mounted() {
      this.runBlockerAction(async () => {
        try {
          const settings = await this.$store.dispatch('getMessagesSettings');
          this.isSeparated = (settings.news !== settings.category) || (settings.category !== settings.remind) || (settings.news !== settings.remind);
          this.settings.news = settings.news;
          this.settings.category = settings.category;
          this.settings.remind = settings.remind;

          if (!this.isSeparated) {
            this.settings.all = settings.news;
          }
        }
        catch(e) {
          console.error('unable to messages settings', e);
          this.globalErrorHandler(e);
        }
      });
    },

    methods: {
      async saveSettings() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('saveMessagesSettings', {
              news: this.isSeparated ? this.settings.news : this.settings.all,
              category: this.isSeparated ? this.settings.category : this.settings.all,
              remind: this.isSeparated ? this.settings.remind : this.settings.all
            });
          }
          catch(e) {
            console.error('unable to update messages settings', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style scoped>
</style>
